const WalletLibError = require('./WalletLibError');

class IdentityIdReplaceError extends WalletLibError {

}
module.exports = IdentityIdReplaceError;
